import {ContactModel, contactModelFactory, contactModelFormGroup} from "../contact/contact.model";
import {AddressModel, addressModelFactory, addressModelFormGroup} from "../address/address.model";
import {FloorModel} from "./floor.model";
import {FormGroup} from "@angular/forms";

export class BuildingModel {
    id: string = "";
    name: string = "";
    tempName?: string;
    projectId?: string;
    siteId: string;
    siteAddressId: string = "";
    siteAddress: AddressModel;
    tempSiteAddress: AddressModel;
    tonerAddressId: string = "";
    tonerAddress?: AddressModel;
    tempTonerAddress?: AddressModel;
    serviceAddressId: string = "";
    serviceAddress?: AddressModel;
    tempServiceAddress?: AddressModel;
    tonerContactId?: string;
    tempTonerContactId?: string;
    tonerContact?: ContactModel = contactModelFactory();
    tempTonerContact?: ContactModel = contactModelFactory();
    breakfixContactId?: string;
    tempBreakfixContactId?: string;
    breakfixContact: ContactModel = contactModelFactory();
    tempBreakfixContact?: ContactModel = contactModelFactory();
    physicalAddressForm: FormGroup = addressModelFormGroup();
    tonerAddressForm: FormGroup = addressModelFormGroup();
    serviceAddressForm: FormGroup = addressModelFormGroup();
    tonerContactForm: FormGroup = contactModelFormGroup();
    serviceContactForm: FormGroup = contactModelFormGroup();
    enableEdit: boolean = false;
    deleteFlag?: boolean = false;
    floor?: FloorModel;
    floors: any = [];
    tempFloors: any = [];
    currentIndex?: string;
}

export function buildingModelFactory(json?: any): BuildingModel {
  json = json || {};
  return {
    id: json.id,
    name: json.name || "",
    tempName: "",
    projectId: json.projectId || json.project_id || "",
    siteId: json.siteId || json.site_id,
    siteAddressId: json.siteAddressId,
    siteAddress: addressModelFactory(json.siteAddress),
    tempSiteAddress: "",
    tonerAddressId: json.tonerAddressId,
    tonerAddress: addressModelFactory(json.tonerAddress) || "",
    tempTonerAddress: "",
    serviceAddressId: json.serviceAddressId,
    serviceAddress: addressModelFactory(json.serviceAddress) || "",
    tempServiceAddress: "",
    tonerContactId: json.tonerContactId || json.toner_contact_id || "",
    tempTonerContactId: "",
    tonerContact: contactModelFactory(json.tonerContact),
    breakfixContactId: json.breakfixContactId || json.breakfix_contact_id || "",
    tempBreakfixContactId: "",
    breakfixContact: contactModelFactory(json.breakfixContact),
    physicalAddressForm: addressModelFormGroup(),
    tonerAddressForm: addressModelFormGroup(),
    serviceAddressForm: addressModelFormGroup(),
    tonerContactForm: contactModelFormGroup(),
    serviceContactForm: contactModelFormGroup(),
    enableEdit: false,
    floors: [],
    tempFloors: [],
  } as BuildingModel;
}

export function buildingModelListFactory(json?: any) {
  return Array.from(json || []).map(building => buildingModelFactory(building));
}
